import { EventEmitter } from "events";
import CobrowseService from "../services/CobrowseService";
import ChatStore from "./ChatStore";
import EngagementStore from "./EngagementStore";

const scriptId = "velaro-cobrowse-script";
const parentWindow = window.parent as Window;

class CobrowseStore {
  private _emitter = new EventEmitter();
  recorder: any;
  private chatStore: ChatStore;
  private engagementStore: EngagementStore;

  constructor(chatStore: ChatStore, engagementStore: EngagementStore) {
    this.chatStore = chatStore;
    this.engagementStore = engagementStore;

    this.chatStore.onReceiveStopCobrowsing(() => {
      this.stopRecording();
    });

    this.engagementStore.onContentLoaded(async (engagement) => {
      if (
        engagement.CobrowseSessionId &&
        engagement.CobrowseState === "Recording"
      ) {
        this._emitter.emit("cobrowseUpdate", engagement.CobrowseState);
        await this.startRecording(
          engagement.CobrowseRootUrl,
          engagement.CobrowseSessionId
        );
      }
    });
  }

  onCobrowseUpdate(callback: (state: string) => void) {
    this._emitter.addListener("cobrowseUpdate", callback);
  }

  async acceptRequest(rootUrl: string, sessionId: string) {
    await this.startRecording(rootUrl, sessionId);
    const engagementId = this.engagementStore.getEngagementId();
    CobrowseService.acceptRequest(engagementId);
  }

  declineRequest() {
    const engagementId = this.engagementStore.getEngagementId();
    CobrowseService.declineRequest(engagementId);
  }

  async startRecording(rootUrl: string, sessionId: string) {
    const scriptUrl = `${rootUrl}/dist/cobrowse.js`;

    await this.initScript(scriptUrl);
    this.initRecorder();

    await this.recorder.connect(rootUrl, sessionId);
    this.recorder?.start();
    this._emitter.emit("cobrowseUpdate", "Recording");
  }

  requestStop() {
    if (!this.recorder) {
      return;
    }
    const engagementId = this.engagementStore.getEngagementId();
    CobrowseService.stopSession(engagementId);
    this.stopRecording();
  }

  stopRecording() {
    if (!this.recorder) {
      return;
    }
    this.recorder.stop();
    this._emitter.emit("cobrowseUpdate", "Stopped");
  }

  initScript(scriptUrl: string) {
    return new Promise((resolve, reject) => {
      if (parentWindow.document.getElementById(scriptId)) {
        return resolve(undefined);
      }

      const script = parentWindow.document.createElement("script");

      script.src = scriptUrl;
      script.defer = true;
      script.id = scriptId;

      script.onload = () => {
        resolve(undefined);
      };

      script.onerror = () => {
        parentWindow.document.head.removeChild(script);
        reject();
      };

      parentWindow.document.head.appendChild(script);
    });
  }

  initRecorder() {
    this.recorder =
      this.recorder || new (parentWindow as any).VelaroCobrowse.Recorder();
  }
}

export default CobrowseStore;
